import FilterIcon from "@assets/icons/filter.svg";
import React from "react";
import { useObservable } from "micro-observables";
import styled from "@emotion/styled";
import { stack } from "@ui/style/layout";
import { exerciseFilterManager } from "@core/service-container";
import { colors } from "@ui/style/colors";

interface FilterButtonProps {
	onClick: () => void;
	className?: string;
}

export const FilterButton: React.FC<FilterButtonProps> = ({ onClick, className }) => {
	const activeFilters = useObservable(exerciseFilterManager.activeFilters);

	return (
		<StyledButton selected={activeFilters.length > 0} onClick={onClick} className={className}>
			<FilterIcon width={24} height={24} />
		</StyledButton>
	);
};

const StyledButton = styled.button<{ selected: boolean }>`
	appearance: none;
	margin: 0;
	padding: 8px;
	border: none;
	position: relative;
	cursor: pointer;
	color: ${({ selected }) => (selected ? colors.primary : colors.grey)};
	${stack(undefined, "center", "center")};
	border-radius: 8px;
	background-color: ${({ selected }) => (selected ? colors.primaryBackground : colors.transparent)};

	:hover {
		background-color: ${colors.primaryBackground};
	}
`;
